import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import NotificationService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";
import { EnsolversOpsUser } from "../models/EnsolversOpsUser";
import UserService from "../services/UserService";
import { AccessRoleType } from "../types/AccessRoleType";
import { AppDialog } from "./AppDialog";

interface Props {
  selectedUser: EnsolversOpsUser | undefined;
  setSelectedUser: (user: EnsolversOpsUser | undefined) => void;
  isEditing: boolean;
  setIsEditing: (arg: boolean) => void;
  setRolesForUser: (user: EnsolversOpsUser) => Promise<void>;
  roles: {
    roleAdmin: boolean;
    roleContractor: boolean;
    roleManager: boolean;
    roleHR: boolean;
    roleHiringManager: boolean;
  };
}

export const EditRoleUser = ({ selectedUser, setSelectedUser, isEditing, setIsEditing, setRolesForUser, roles }: Props) => {
  const closeEditRoles = () => {
    setSelectedUser(undefined);
    setIsEditing(false);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsEditing(true);
    const externalId: string = selectedUser?.externalId!;
    UserService.setRole(selectedUser?.email!, event.target.name, event.target.checked)
      .then((response) => {
        if (response.isSuccess()) {
          UserService.getByExternalId(externalId).then((response) => {
            setRolesForUser(response.getContentOrThrowError());
            setSelectedUser(response.getContentOrThrowError());
          });
          NotificationService.info("The data has been updated successfully!");
        } else {
          NotificationService.error(response.getMessage());
        }
      })
      .catch((error) => {
        NotificationService.error("Error trying to update user role.");
      });
  };

  return (
    <AppDialog
      open={!!selectedUser && !!isEditing}
      hideCancel
      onClose={() => closeEditRoles()}
      buttons={[{ label: "Close", onClick: () => closeEditRoles() }]}
      title={`Edit Roles: ${selectedUser?.firstName} ${selectedUser?.lastName}.`}
      content={
        <>
          <FormGroup>
            <FormControlLabel
              control={<Checkbox checked={roles.roleAdmin} onChange={handleChange} name={AccessRoleType.ROLE_ADMIN} />}
              label="Role Admin"
            />
            <FormControlLabel
              control={<Checkbox checked={roles.roleContractor} onChange={handleChange} name={AccessRoleType.ROLE_CONTRACTOR} />}
              label="Role Contractor"
            />
            <FormControlLabel
              control={<Checkbox checked={roles.roleHR} onChange={handleChange} name={AccessRoleType.ROLE_HR} />}
              label="Role HR"
            />
            <FormControlLabel
              control={<Checkbox checked={roles.roleManager} onChange={handleChange} name={AccessRoleType.ROLE_MANAGER} />}
              label="Role Manager"
            />
            <FormControlLabel
              control={<Checkbox checked={roles.roleHiringManager} onChange={handleChange} name={AccessRoleType.ROLE_HIRING_MANAGER} />}
              label="Role Hiring Manager"
            />
          </FormGroup>
        </>
      }
    />
  );
};
